import { render } from "./MyContracts.vue?vue&type=template&id=4ca72d32&scoped=true"
import script from "./MyContracts.vue?vue&type=script&lang=js"
export * from "./MyContracts.vue?vue&type=script&lang=js"

import "./MyContracts.vue?vue&type=style&index=0&id=4ca72d32&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ca72d32"]])

export default __exports__